/**
 * Created by Ning Jiang on 2022-06-14.
 */

import {gsap} from "gsap";
import {WinCapEndScreen} from "./WinCapEndScreen";
import {WinCapView} from "./WinCapView";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {Serial} from "../../Serial";
import {BelowStakeWinRestriction} from "../../server/BelowStakeWinRestriction";
import {Layers, SerialLayers} from "../../view/SerialLayers";

export class WinCapController {

    private _countUpDuration:number = 2;

    private _wpTimeline:TimelineLite | null;

    private _view:WinCapView;
    private _endScreen:WinCapEndScreen;
    private _currentLevel:number;

    constructor() {
        this._view = new WinCapView();
        this._endScreen = new WinCapEndScreen();
    }

    public playWinPresentation(level:number):Promise<any> {
        const levelAmount = Serial.model.parsedGameData.playedBetValue * 18700;
        const tl = this._view.playWinPresentation(level);
        const countUpTl = gsap.timeline();
        countUpTl.add([
            () => {Serial.screenCountUp.scale.set(1.2);},
            Serial.screenCountUp.getCountUpAnimation(levelAmount * level, levelAmount * (level + 1), this._countUpDuration, SerialLayers.getLayer(Layers.SCREENS)!, 50),
            gsap.to(Serial.screenCountUp.scale, {duration : this._countUpDuration, x : 1, y : 1, ease : `power4.out`}),
        ], level > 0 ? 0.8 : 0.5);
        countUpTl.add(() => {
            SlotGame.keypadPlugin.setWin(Serial.model.parsedGameData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        });
        countUpTl.add(gsap.to(Serial.screenCountUp.scale, {
            duration : 0.5,
            x : 1.05,
            y : 1.05,
            ease : `elastic.out(2, 0.75)`
        }));
        countUpTl.add(gsap.to(Serial.screenCountUp.scale, {duration : 0.5, x : 1, y : 1, ease : `elastic.out(1, 1)`}),);

        if(level > 0) {
            tl.add(() => this._view.playAddMoney(), 0.1);
        }
        tl.add(countUpTl, 0);
        if(level > 0) {
            tl.add(() => {this._view.playText(true)});
            tl.add(this._view.playNextLevelIntro(level));
        }
        tl.add(() => {
            this._wpTimeline = null;
        });
        this._wpTimeline = tl;
        return Promise.resolve(tl);
    }

    public playFailedPresentation(level:number):Promise<any> {
        SlotGame.keypadPlugin.setWin(Serial.model.parsedGameData.totalWin, true, BelowStakeWinRestriction.isWinBelowStake());
        return Promise.resolve(this._view.playFailPresentation(level));
    }

    public async playPickLevel(level:number, clickCallback:() => void):Promise<any> {
        this._currentLevel = level;
        // resolve on button clicked.
        await this._view.showPickLevel(level).then(async value => {
            Logger.logDev(`Selected index = ${value.index}`);
            this._view.disablePick(); // also remove buttons.
            SlotGame.apiPlugin.betHandler.pickAndClickBet(value.index, false);
            await Promise.resolve(this._view.playButtonClick(level, value.index, value.replay));
        });
        this._view.hideAllButtons();
        clickCallback();
    }

    public async wait():Promise<any> {
        return this._view.wait(this._currentLevel);
    }

    public async showEnding():Promise<any> {
        await new Promise<void>(res => {
            this._endScreen.show(() => {
                this._currentLevel = -1;
                res();
            });
        });
    }

    public close():void {
        this._view.close();
    }
}